import React, { useMemo } from 'react'

import { Plugin } from '@egjs/flicking'
import { Pagination } from '@egjs/flicking-plugins'

const usePaginationPlugin = (paginationType?: Pagination['type']) =>
  useMemo<[Plugin | undefined, React.FC]>(() => {
    if (!paginationType) return [undefined, () => null]

    const plugin = new Pagination({
      selector: '.place-flicking-pagination',
      classPrefix: 'place-flicking-pagination',
      type: paginationType,
    })
    const PluginComponent: React.FC = () => {
      return <div className="place-flicking-pagination" />
    }
    return [plugin, PluginComponent]
  }, [paginationType])
export default usePaginationPlugin
